export const localStorageKeys = {
  trainerUUID: "trainer-uuid",
  trainerAccessToken: "trainer-token",
  adminAccessToken: "admin-token",
  isAdmin: "is-admin",
};
